import jwtDecode from 'jwt-decode';
import { routesNames } from '../enums/routesNames';
import { Permissions } from '../enums/permissionsEnum';

class PermissionCheckService {
	currentUserPermissions = [];
	selectedProject = null;

	hasRoutePermission(routeName) {
		let superAdmin = localStorage.bearer
			? jwtDecode(localStorage.bearer).SuperAdmin === 'true'
			: false;
		if (superAdmin) return true;
		switch (routeName) {
			case routesNames.LOGIN:
			case routesNames.HOMEPAGE:
			case routesNames.RESTRICTED_ACCESS:
			case routesNames.MY_PROFILE:
				return true;
			case routesNames.ACTIVITY_GRID:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Activity.View
				);
			case routesNames.DATASETS_GRIDS:
			case routesNames.DATASETS_HISTORY:
			case routesNames.DATASETS_RECORD_HISTORY:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Grids.View
				);
			case routesNames.DATASETS_ADD:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Grids.Add
				);
			case routesNames.DATASETS_EDIT:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Grids.Edit
				);
			case routesNames.INVENTORY:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Inventory.View
				);
			case routesNames.INVENTORY_GRID:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Inventory.View
				);
			case routesNames.INVENTORY_FORM:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Inventory.View
				);
			case routesNames.INVENTORY_FORM_HISTORY:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Inventory.View
				);
			case routesNames.REPORT_WORKBOOK:
			case routesNames.REPORT_GRID_CUSTOM:
			case routesNames.REPORTS:
			case routesNames.REPORT_GRID:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Reports.View
				);
			case routesNames.PROJECT_CLONE:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.ProjectClone.View
				);
			case routesNames.FORM_BUILDER:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.FormBuilder.View
				);
			case routesNames.EDIT_INVENTORY_FORM:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.FormBuilder.Edit
				);
			case routesNames.ADD_INVENTORY_FORM:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.FormBuilder.Add
				);
			case routesNames.ACTIVITY_BUILDER:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.ActivityBuilder.View
				);
			case routesNames.EDIT_ACTIVITY:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.ActivityBuilder.Edit
				);
			case routesNames.ADD_ACTIVITY:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.ActivityBuilder.Add
				);
			case routesNames.DATA_IMPORT:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.DataImport.View
				);
			case routesNames.DATA_EXPORT:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.DataExport.View
				);
			case routesNames.DATA_IMPORT_TEMPLATES:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.DataImport.Templates.View
				);
			case routesNames.USER_MANAGEMENT_ADMIN_EDIT:
				return false;
			case routesNames.USER_MANAGEMENT_ADMIN_ADD:
				return false;
			case routesNames.USER_MANAGEMENT: {
				let edit = this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.UserManagement.Edit
				);
				let add = this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.UserManagement.Add
				);
				return edit || add;
			}
			case routesNames.USER_MANAGEMENT_CLIENT_EDIT:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.UserManagement.Edit
				);
			case routesNames.USER_MANAGEMENT_CLIENT_ADD:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.UserManagement.Add
				);
			case routesNames.REPORT_BUILDER:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.ReportBuilder.Report.View
				);
			case routesNames.REPORT_DETAILS:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.ReportBuilder.Report.View
				);
			case routesNames.WORKBOOK_DETAILS:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Tools.ReportBuilder.Workbook.View
				);
			case routesNames.DATABASE_TABLES:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Settings.DataFields.View
				);
			case routesNames.DATASET_FIELDS:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Settings.GridFields.View
				);
			case routesNames.GENERAL_SETTINGS:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Settings.GeneralSettings.View
				);
			case routesNames.MERGE_CONDITIONS:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Settings.MergeConditions.View
				);

			case routesNames.PERMISSIONS:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Settings.Permissions.View
				);
			case routesNames.REFERENCE_LISTS:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Settings.ReferenceLists.View
				);
			case routesNames.CONNECTORS:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.Settings.Connectors.View
				);
			case routesNames.CLIENTS:
				return false;
			case routesNames.CLIENTS_EDIT:
				return false;
			case routesNames.CLIENTS_ADD:
				return false;
			case routesNames.PROJECTS:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.ProjectManagement.View
				);
			case routesNames.PROJECTS_EDIT:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.ProjectManagement.Edit
				);
			case routesNames.PROJECTS_ADD:
				return this.hasPermissions(
					this.currentUserPermissions,
					Permissions.ProjectManagement.Add
				);
			default:
				return false;
		}
	}

	hasPermissions(userPermissions, permissionNames) {
		if (!Array.isArray(permissionNames)) {
			permissionNames = [permissionNames];
		}
		let hasPermission = true;
		permissionNames.forEach((permission) => {
			if (!userPermissions.map((x) => x.Name).includes(permission)) {
				hasPermission = false;
			}
		});
		return hasPermission;
	}
}
const permissionCheckService = new PermissionCheckService();
export default permissionCheckService;
